// ============================================================================
// TARJAN SCC - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'tarjan-scc',
  name: 'Tarjan SCC',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'An algorithm for finding strongly connected components in a directed graph using a single DFS pass. It maintains discovery times and low values to identify SCCs on the fly during the traversal.'
};
